/**
 * @ngdoc run
 * @memberof mercury.modules.thirdparty.survicate
 * @name SurvicateRun
 * @description Survicate functionality, initialised during app startup once there
 */
angular.module('mercury.modules.thirdparty.survicate')
.run(["$window", "logger", "userinfo", "settings", function survicateRun($window, logger, userinfo, settings) {

  function configureSurvicate(opts) {
    var config = ($window._sva = $window._sva || {});
    config.traits = opts;
  }

  function startSurvicateWidget() {
    var script = document.createElement('script');
    script.src = settings.survicateScript;
    script.async = true;
    var head = document.querySelector('head');
    head.appendChild(script);
  }

  // Main Survicate module entrypoint, awaits user info before proceeding
  userinfo.ready()
    .then(function(userDetails) {

      var config = {
        email: userDetails.email,
        /* jshint ignore:start */
        //jscs:disable requireCamelCaseOrUpperCaseIdentifiers
        first_name: userDetails.firstName,
        last_name: userDetails.lastName
        //jscs:enable requireCamelCaseOrUpperCaseIdentifiers
        /* jshint ignore:end */
      };

      logger.info('Survicate configured with :: %o', config);

      // We neeed to configure Survicate prior to starting the widget to ensure
      // the right configs are used once it loads.
      configureSurvicate(config);

      startSurvicateWidget();
    });

}]);
